import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import { usePublishedAdaptationStories, usePublishedAdaptationPlans } from '@services/query.service';
import { useTranslation } from '@utils/i18n/i18n.consumers';
import { useMapBounds } from '@services/hooks.service';

import AdaptationListComponent from '../AdaptationListComponent';
import AdaptationStoryActionCard from '../../AdaptationStoryActionCard/AdaptationStoryActionCard';
import MapMarkerLayer from '../../MapMarkerLayer/MapMarkerLayer';
import { mapBoundsFilter } from '../adaptation-list-component.utils';

import './all-list.styl';

function AllList() {
  const { t } = useTranslation();

  const map = useSelector(state => state.maplibremap.map);

  const [selectedMarker, setSelectedMarker] = useState(null);

  const { data: adaptationStories = [], isLoading: isLoadingStories } = usePublishedAdaptationStories();
  const { data: adaptationPlans = [], isLoading: isLoadingPlans } = usePublishedAdaptationPlans();

  const allData = useMemo(() => [
    ...(Array.isArray(adaptationStories) ? adaptationStories : []),
    ...(Array.isArray(adaptationPlans) ? adaptationPlans : []),
  ], [adaptationStories, adaptationPlans]);

  const mapBounds = useMapBounds(map);
  const filteredData = mapBoundsFilter(allData, mapBounds);

  return (
    <div className="all-list">
      <AdaptationListComponent selectedCategory="all" />
      {!isLoadingStories && !isLoadingPlans && filteredData.length === 0 && (
        <div className="all-list__no-data">
          <span>{t('No plans/stories here yet. Zoom out or pan on the map to find more plans/stories.')}</span>
        </div>
      )}
      <div className="all-list__cards">
        {filteredData.map(card => (
          <AdaptationStoryActionCard key={card.id} data={card} selectedData={selectedMarker} />
        ))}
      </div>
      <MapMarkerLayer
        markerData={allData}
        setSelectedMarker={setSelectedMarker}
        selectedMarker={selectedMarker}
      />
    </div>
  );
}

export default AllList;
